import React from 'react';
import LogoResizer from '@gin-betting/components/logo-resizer';

import { Icon } from 'components';

import stubImage from 'assets/svg/top-tournament.svg';
import './featuredTournamentsLogo.scss';

interface Props {
    logo: string | undefined;
}

const FeaturedTournamentsLogo: React.FC<Props> = ({ logo }) => (
    <div styleName="container">
        {logo ? (
            <LogoResizer url={logo} isOutsource={true}>
                {({ ref, bgImageStyle }) => (
                    <div styleName="logo" style={bgImageStyle} ref={ref} />
                )}
            </LogoResizer>
        ) : (
            <Icon glyph={stubImage} styleName="icon" />
        )}
    </div>
);

export default FeaturedTournamentsLogo;
